function NumberBox({name}) {
  return (
    <div className="number-box">
      <div className="number-box__name">{name}</div>
    </div>
  )
}

export default NumberBox